<div [formGroup]="lifeCoverageForm">
    <span class="fs-4 fw-600">Variables Coberturas de Vida </span> <small class="text-muted">(Tasa por mil)</small>
    <br>
    <div class="row my-2">
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Vida
            <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Vida" formControlName="life"
                    (blur)="updateCollection(lifeCoverageForm.value)">
                <div class="input-group-text">
                    <label class="form-check-label" for="checkIVAVida"> IVA </label>
                    <input class="form-check-input mt-0 mx-2" type="checkbox" id="checkIVAVida"
                        formControlName="taxesLife" (blur)="updateCollection(lifeCoverageForm.value)">
                </div>
            </div>
        </div>
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Muerte Accidental
            <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Muerte Accidental" formControlName="ma"
                    (blur)="updateCollection(lifeCoverageForm.value)">
                <div class="input-group-text">
                    <label class="form-check-label" for="checkIVAMuerteAccidental"> IVA </label>
                    <input class="form-check-input mt-0 mx-2" type="checkbox" id="checkIVAMuerteAccidental"
                        formControlName="taxesMa" (blur)="updateCollection(lifeCoverageForm.value)">
                </div>
            </div>
        </div>
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Invalidez 2/3
            <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Invalidez 2/3" formControlName="inv23"
                    (blur)="updateCollection(lifeCoverageForm.value)">
                <div class="input-group-text">
                    <label class="form-check-label" for="checkIVAIvaInvalidez2/3"> IVA </label>
                    <input class="form-check-input mt-0 mx-2" type="checkbox" id="checkIVAIvaInvalidez2/3"
                        formControlName="taxesInv23" (blur)="updateCollection(lifeCoverageForm.value)">
                </div>
            </div>
        </div>
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Invalidez Accidental
            <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Invalidez Accidental" formControlName="invacc"
                    (blur)="updateCollection(lifeCoverageForm.value)">
                <div class="input-group-text">
                    <label class="form-check-label" for="checkIVAIvaInvalidezAccidental"> IVA </label>
                    <input class="form-check-input mt-0 mx-2" type="checkbox" id="checkIVAIvaInvalidezAccidental"
                        formControlName="taxesInvacc" (blur)="updateCollection(lifeCoverageForm.value)">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="d-flex justify-content-between mt-5">
    <span class="fs-4 fw-600">Variables Coberturas de Salud</span>
    <button type="button" class="btn btn-primary btn-sm" (click)="createSection()">Añadir Tramo</button>
</div>
<div [formGroup]="collectionsForm">
    <div formArrayName="collections">
        @for(coverage of collectionsArray.controls; track $index; let i = $index){
        <div class="row my-2" [formGroupName]="i">
            <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
                Cargas
                <div class="input-group mb-3">
                    <input type="text" class="form-control" value="0" formControlName="dependent"
                        (blur)="updateCollection(coverage.value)">
                </div>
            </div>
            <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
                Salud
                <div class="input-group mb-3">
                    <input type="text" class="form-control" placeholder="Salud" formControlName="health"
                        (blur)="updateCollection(coverage.value)">
                    <div class="input-group-text">
                        <label class="form-check-label" for="checkIVASalud"> IVA </label>
                        <input class="form-check-input mt-0 mx-2" type="checkbox" id="checkIVASalud"
                            formControlName="taxesHealth" (blur)="updateCollection(coverage.value)">
                    </div>
                </div>
            </div>
            <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
                Catastrófico
                <div class="input-group mb-3">
                    <input type="text" class="form-control" placeholder="Catastrófico" formControlName="catas"
                        (blur)="updateCollection(coverage.value)">
                    <div class="input-group-text">
                        <label class="form-check-label" for="checkIVCatastrofico"> IVA </label>
                        <input class="form-check-input mt-0 mx-2" type="checkbox" id="checkIVCatastrofico"
                            formControlName="taxesCatas" (blur)="updateCollection(coverage.value)">
                    </div>
                </div>
            </div>
            <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
                Dental
                <div class="input-group mb-3">
                    <input type="text" class="form-control" placeholder="Dental" formControlName="dental"
                        (blur)="updateCollection(coverage.value)">
                    <div class="input-group-text">
                        <label class="form-check-label" for="checkIVAIvaDental"> IVA </label>
                        <input class="form-check-input mt-0 mx-2" type="checkbox" id="checkIVAIvaDental"
                            formControlName="taxesDental" (blur)="updateCollection(coverage.value)">
                    </div>
                </div>
            </div>
            @if(collectionsArray.length > 1){
            <div class="mt-2 col-xl-3 col-sm-6 col-xs-12 text-center align-self-center">
                <button class="btn btn-sm btn-danger" (click)="deleteStage(coverage.value)"><i class="fas fa-trash"></i>
                    Eliminar Tramo</button>
            </div>
            }

        </div>
        }
    </div>

</div>


<hr>
<div [formGroup]="lifeCoverageForm">
    <span class="fs-4 fw-600 mt-2">Edad Limite de Permanencia</span> <small class="text-muted"> (Edad en la cual ya no
        se considera cubierto)</small>
    <div class="row my-2">
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Edad Límite Hijos
            <div class="input-group mb-3">
                <input type="text" class="form-control" formControlName="limitChildren" value="0"
                    (blur)="updateCollection(lifeCoverageForm.value)">
            </div>
        </div>
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Vida
            <div class="input-group mb-3">
                <input type="text" class="form-control" formControlName="limitLife"
                    (blur)="updateCollection(lifeCoverageForm.value)">
            </div>
        </div>
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Muerte Accidental
            <div class="input-group mb-3">
                <input type="text" class="form-control" formControlName="limitMa"
                    (blur)="updateCollection(lifeCoverageForm.value)">
            </div>
        </div>
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Invalidez 2/3
            <div class="input-group mb-3">
                <input type="text" class="form-control" formControlName="limitInv23"
                    (blur)="updateCollection(lifeCoverageForm.value)">
            </div>
        </div>
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Invalidez Accidental
            <div class="input-group mb-3">
                <input type="text" class="form-control" formControlName="limitInvacc"
                    (blur)="updateCollection(lifeCoverageForm.value)">
            </div>
        </div>
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Salud
            <div class="input-group mb-3">
                <input type="text" class="form-control" formControlName="limitHealth"
                    (blur)="updateCollection(lifeCoverageForm.value)">
            </div>
        </div>
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Catastrófico
            <div class="input-group mb-3">
                <input type="text" class="form-control" formControlName="limitCatas"
                    (blur)="updateCollection(lifeCoverageForm.value)">
            </div>
        </div>
        <div class="mt-2 col-xl-3 col-sm-6 col-xs-12">
            Dental
            <div class="input-group mb-3">
                <input type="text" class="form-control" formControlName="limitDental"
                    (blur)="updateCollection(lifeCoverageForm.value)">
            </div>
        </div>
    </div>
</div>